import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import HVAC images
import acMaintenanceImage from '../assets/images/services/hvac/AC MAINTENANCE.jpg';
import vrfImage from '../assets/images/services/hvac/VRF .jpg';

// Import HVAC video
import hvacVideo from '../assets/videos/services/HAVC_Cooling_Technology_Visualization.mp4';

// Import HVAC benefits image
import hvacBenefitsImage from '../assets/images/services/hvac/AC SPLIT.jpg';

const HVACSolutionsPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="HVAC Solutions" description="Professional HVAC installation and maintenance in DRC: air conditioning, VRF systems, commercial and residential cooling by Cool & Care." keywords="HVAC DRC, air conditioning installation, VRF systems, AC maintenance, cooling solutions Kinshasa" />
      <ServiceSchema name="HVAC Solutions" description="Professional HVAC installation and maintenance including AC, VRF systems for commercial and residential." url="/hvac-solutions" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'HVAC Solutions', url: '/hvac-solutions' }]} />
      <ServicePage
        serviceName={t('servicePage.services.hvacSolutions.name')}
      serviceDescription={t('servicePage.services.hvacSolutions.description')}
      videoUrl={hvacVideo}
      productImages={[
        acMaintenanceImage,
        vrfImage
      ]}
      features={t('servicePage.services.hvacSolutions.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.hvacSolutions.benefits', { returnObjects: true }) as string[]}
      benefitsImage={hvacBenefitsImage}
    />
    </>
  );
};

export default HVACSolutionsPage;
